import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  BankAccount as ApiBankAccount,
  DeleteBankAccountRequest,
  ListBankAccountsRequest,
  ListBankAccountsResponse,
  MerchantApiService,
  SetDefaultBankAccountRequest,
} from '@vendasta/billing';
import { BankAccount, bankAccountFromApi } from './bank_account';

@Injectable({ providedIn: 'root' })
export class BankAccountService {
  constructor(private merchantApi: MerchantApiService) {}

  listBankAccounts(merchantId: string): Observable<BankAccount[]> {
    return this.merchantApi
      .listBankAccounts(
        new ListBankAccountsRequest({
          merchantId,
        }),
      )
      .pipe(
        map((res: ListBankAccountsResponse) => (res && res.bankAccount ? res.bankAccount : [])),
        map((bankAccounts: ApiBankAccount[]) => {
          return bankAccounts.map((ba: ApiBankAccount) => bankAccountFromApi(ba));
        }),
      );
  }

  setDefaultBankAccount(merchantId: string, bankAccountId: string): Observable<HttpResponse<null>> {
    const request = new SetDefaultBankAccountRequest({
      merchantId,
      bankAccountId,
    });
    return this.merchantApi.setDefaultBankAccount(request);
  }

  deleteBankAccount(merchantId: string, bankAccountId: string): Observable<HttpResponse<null>> {
    const request = new DeleteBankAccountRequest({
      merchantId,
      bankAccountId,
    });
    return this.merchantApi.deleteBankAccount(request);
  }
}
